// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1USyP","errors":"Errors_errors__2qEST"};